import { render, staticRenderFns } from "./reversement.vue?vue&type=template&id=21906f7a&scoped=true"
import script from "./reversement.vue?vue&type=script&lang=js"
export * from "./reversement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21906f7a",
  null
  
)

export default component.exports